<template>
  <!-- 发车详情 -->
  <div>
    <!-- 输入批次号 -->
    <div class="formbox">
      <el-form :model="baseInForm" ref="baseInFormRef" label-width="100px" class="glo_formBox">
        <div class="teSu">
          <el-form-item label="发车批次号:" prop="dispatchId">
            <!-- <el-input
              v-model="baseInForm.waybillNumber"
              placeholder="请输入"
              clearable
            ></el-input>-->
            <el-select filterable clearable v-model="dispatchId" placeholder="请输入" @focus="getPCH()" @change="changePCH" remote :remote-method="getPCH">
              <el-option v-for="(item, index) in NumberList" :key="index" :label="item.number" :value="item.dispatchId"></el-option>
            </el-select>
          </el-form-item>
          <el-button class="glo_bgcMainColor formBtns" @click="queryBtns">搜索</el-button>
        </div>
      </el-form>
    </div>
    <el-tabs class="glo_tabs" type="border-card" v-model="activeName" @tab-click="tabsClick">
      <!-- =====配载明细===== -->
      <el-tab-pane label="配载明细" name="first">
        <LoadingDetails :dispatchId="dispatchId" ref="refLoadingDetails"></LoadingDetails>
      </el-tab-pane>
      <!-- =====任务模式===== -->
      <el-tab-pane label="任务模式" name="one">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button v-if="hasPermiss('admin:task:loadSure')" class="glo_btnItems glo_bgcMainColor" @click="loadSureMore">装货确认</el-button>
            <el-button v-if="hasPermiss('admin:task:unloadSure')" class="glo_btnItems glo_bgcMainColor" @click="unloadSure">卸货确认</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:cancelLoadSur')" class="glo_btnItems" @click="cancelLoadSure">取消装货</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:cancelunloadSure')" class="glo_btnItems" @click="cancelunloadSure">取消卸货</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:arrivalLoad')" class="glo_btnItems" @click="arrivalLoad">装货到车</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:arrivalUnload')" class="glo_btnItems" @click="arrivalUnload">卸货到车</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:cancelArrivalLoad')" class="glo_btnItems" @click="cancelArrivalLoad">取消装货到车</el-button>
            <el-button v-if="hasPermiss('admin:dispatch:cancelArrivalUnload')" class="glo_btnItems" @click="cancelArrivalUnload">取消卸货到车</el-button>
            <el-button @click="wtl_chargeback" v-if="hasPermiss('admin:dispatch:chargeback')" class="glo_btnItems">退单</el-button>
            <el-button @click="wtl_outgoingStation" v-if="hasPermiss('admin:dispatch:outgoingStation')" class="glo_btnItems">外发到站</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table :height="tableHeigth2" header-align="center" ref="mytable2" @row-click="rowclick2" :data="tableDataRight" border stripe @selection-change="handleSelectionChange">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in myTableHeardLeft">
              <el-table-column
                v-if="item.field == 'goodsNames' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel" @click.stop="getGoodsNameDetails(scope.row)">货物明细</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====线路模式===== -->
      <el-tab-pane label="线路模式" name="two">
        <div>
          途径站点:
          <span style="color: #f00">{{ tableData4.length || 0 }} 个</span>
        </div>
        <div class="glo_Table">
          <el-table :height="tableHeigth4" header-align="center" ref="mytable4" :data="tableData4" border stripe>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <!-- <el-table-column fixed="right" label="操作" min-width="210">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    v-if="scope.$index > 0"
                    @click.stop="moveUp(scope.$index)"
                    >上移</el-button
                  >
                  <el-button
                    v-if="scope.$index !== tableData4.length - 1"
                    class="rbtns"
                    @click.stop="moveDown(scope.$index)"
                    >下移</el-button
                  >
                  <el-button
                    v-if="scope.$index > 0"
                    class="rbtns"
                    @click.stop="moveTop(scope.$index)"
                    >置顶</el-button
                  >
                  <el-button
                    v-if="scope.$index !== tableData4.length - 1"
                    class="rbtns"
                    @click.stop="moveBottom(scope.$index)"
                    >置底</el-button
                  >
                </div>
              </template>
            </el-table-column>-->
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====配置预览===== -->
      <el-tab-pane label="配置预览" name="three">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList2">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="reload2()">刷新</el-button>
          </div>
        </div>
        <!-- 预览详情 -->
        <div class="detailsBox" ref="detailsBox2">
          <div class="item">
            <div class="dItemLabel">发车批次号:</div>
            <div class="dItemVal">{{ CarInfo.number }}</div>
          </div>
          <div class="item">
            <div class="dItemLabel">车型:</div>
            <div class="dItemVal">{{ CarInfo.carType }}</div>
            <!-- <div class="ditemBtn">更换</div> -->
          </div>
          <div class="item">
            <div class="dItemLabel">最大载重(kg):</div>
            <div class="dItemVal">{{ CarInfo.loadableCapacity || "暂无信息" }}</div>
          </div>
          <div class="item">
            <div class="dItemLabel">最大体积(m³):</div>
            <div class="dItemVal">{{ CarInfo.loadableVolume || "暂无信息" }}</div>
          </div>
          <div class="item">
            <div class="dItemLabel">车牌号:</div>
            <div class="dItemVal">{{ CarInfo.carNumber }}</div>
          </div>
          <div class="item">
            <div class="dItemLabel">司机:</div>
            <div class="dItemVal">{{ CarInfo.driverName }}</div>
          </div>
          <div class="item">
            <div class="dItemLabel">押运员:</div>
            <div class="dItemVal">{{ CarInfo.supercargoName }}</div>
          </div>
        </div>

        <div class="glo_Table">
          <el-table :height="tableHeigth3" header-align="center" :data="tableDataRight" border stripe>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in myTableHeardLeft">
              <el-table-column
                v-if="item.field == 'goodsNames' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel" @click.stop="getGoodsNameDetails(scope.row)">货物明细</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====财务信息===== -->
      <el-tab-pane label="财务信息" name="four">
        <div class="h3title">财务应付</div>
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable51" :data="tableData51" border stripe @selection-change="handleSelectionChange51" show-summary>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in myTableHeard5">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <div class="h3title">财务应收</div>
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable52" :data="tableData52" border stripe @selection-change="handleSelectionChange52" show-summary>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in myTableHeard5">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====出车确认===== -->
      <el-tab-pane label="出车确认" name="five">
        <el-form ref="form" :model="formData5" style="width: 600px" label-width="120px">
          <el-form-item label="出发前公里数">
            <el-input readonly v-model="formData5.startMileage" placeholder></el-input>
          </el-form-item>
          <el-form-item label="车辆状态">
            <el-checkbox-group v-model="formData5.checkItemConfDictIds" disabled>
              <el-checkbox v-for="(item, index) in start_car_check_item_list" :key="index" :label="item.confDictId" name="type">{{ item.key }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="出发前图片">
            <uploadimgs @input="changeFileList" :fileNameLists="fileNameListsfq" :limit="9"></uploadimgs>
          </el-form-item>
          <el-form-item label="出发备注">
            <el-input type="textarea" placeholder readonly v-model="formData5.startRemarks"></el-input>
          </el-form-item>

          <el-form-item label="发车完成公里数">
            <el-input readonly v-model="formData5.endMileage" placeholder></el-input>
          </el-form-item>
          <el-form-item label="发车完成图片">
            <uploadimgs @input="changeFileListfh" :fileNameLists="fileNameListsfh" :limit="9"></uploadimgs>
          </el-form-item>
          <el-form-item label="发车完成备注">
            <el-input type="textarea" placeholder readonly v-model="formData5.endRemarks"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- =====操作日志===== -->
      <el-tab-pane label="操作日志" name="six">
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable6" :data="tableData6" border stripe>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>

            <template v-for="(item, index) in myTableHeard6">
              <el-table-column :key="index" :label="item.name" :prop="item.field" align="center" sortable :show-overflow-tooltip="true" :min-width="item.width" :data-isTotal="item.isTotal"></el-table-column>
            </template>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 货物信息 -->
    <goodsnamedetail :diaWidth="diaWidth3" :dialogTitle3="dialogTitle3" :isShowDialog3="isShowDialog3" :goodsNameData="goodsNameData" @handleCloseDia3="handleCloseDia3"></goodsnamedetail>

    <!-- 卸货确认 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog2" class="diaForm" ref="dialogFormRef" :model="dialogForm2" label-width="100px" :rules="rulesForm2">
          <el-form-item class="dialogFormItems" prop="unloadType" label="卸货类型:">
            <el-select v-model="dialogForm2.unloadType" placeholder="请选择">
              <el-option v-for="(item, idx) in unloadTypeList" :key="idx" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="returnCangReason" label="回仓原因:" v-if="dialogForm2.unloadType == 'hui_cang:unload_type'">
            <el-select v-model="dialogForm2.returnCangReason" placeholder="请选择">
              <el-option v-for="(item, index) in returnCangReasonList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isOutGoing" label="是否外发到站:" v-if="dialogForm2.unloadType == 'zheng_chang:unload_type'">
            <el-select v-model="dialogForm2.isOutGoing" placeholder="请选择">
              <el-option v-for="(item, idx) in isOutGoingList" :key="idx" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="returnCangStorageId" label="回仓仓库:" v-if="dialogForm2.unloadType == 'hui_cang:unload_type'">
            <el-select v-model="dialogForm2.returnCangStorageId" placeholder="请选择">
              <el-option v-for="(item, index) in storageList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="dialogForm2.isOutGoing == '0'" class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.remarks"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogForm2.isOutGoing == '1'" class="dislogFormTextarea" prop="outgoingRemarks" label="外发备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.outgoingRemarks"></el-input>
          </el-form-item>
          <el-form-item style="width: 100%" label="卸货图片:">
            <uploadimgs @input="changeFileList2" :fileNameLists="fileNameLists2" :limit="9"></uploadimgs>
          </el-form-item>
          <el-form-item style="width: 100%" v-if="dialogForm2.isOutGoing == '1'" label="外发图片:">
            <uploadimgs @input="changeFileList3" :fileNameLists="fileNameLists3" :limit="9"></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 退单 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4('dialogFormRef4')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog4" class="diaForm" ref="dialogFormRef4" :model="dialogForm4" label-width="100px" :rules="rulesForm4">
          <el-form-item class="dialogFormItems" prop="returnCangReason" label="退单原因:">
            <el-select v-model="dialogForm4.returnCangReason" placeholder="请选择">
              <el-option v-for="(item, index) in returnCangReasonList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm4.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 外发到站 -->
    <myDialog
      :diaWidth="diaWidth5"
      :dialogTitle="dialogTitle5"
      :isShowDialog="isShowDialog5"
      @handleCloseDia="handleCloseDia5"
      @diaCancelBtn="handleCloseDia5"
      @diaConfirmBtn="diaConfirmBtn5('dialogFormRef5')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog5" class="diaForm" ref="dialogFormRef5" :model="dialogForm5" label-width="100px" :rules="rulesForm5">
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm5.remarks"></el-input>
          </el-form-item>
          <el-form-item style="width: 100%" label="上传图片:">
            <uploadimgs @input="changeFileList5" :fileNameLists="fileNameLists5" :limit="9"></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 装货确认-->
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog1" class="diaForm" ref="dialogForm1" :model="dialogForm1" label-width="100px" :rules="rulesForm1">
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm1.aaa"></el-input>
          </el-form-item>-->

          <el-form-item class="dislogFormTextarea" prop="remarks" label="已选任务:">
            <el-input type="textarea" rows="2" v-model="dialogForm1.taskStr" disabled></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm1.remarks"></el-input>
          </el-form-item>
          <el-form-item label="装货图片:">
            <uploadimgs @input="changeFileList_zh" :fileNameLists="fileNameLists1" :limit="9"></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import goodsnamedetail from "@/components/goodsNameDetails.vue";
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import LoadingDetails from "./ComNewStowageEditRX/LoadingDetails.vue";
export default {
  components: {
    goodsnamedetail,
    myDialog,
    uploadimgs,
    LoadingDetails,
  },
  data() {
    return {
      diaWidth3: "80%",
      dialogTitle3: "货物明细",
      isShowDialog3: false,
      goodsNameData: [],

      selectTableDataRight: [],
      baseInForm: {
        waybillNumber: "",
      },
      NumberList: [], //批次号列表
      dispatchId: "",
      activeName: "first",
      tableHeigth2: "73vh",
      tableHeigth3: "63vh",
      tableHeigth4: "73vh",
      // 第一步添加任务的表头
      myTableHeard: [
        {
          name: "运单号",
          field: "memberNickname",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "快递单号",
          field: "courierNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "出库单号",
          field: "billStorepackNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "转单号",
          field: "billStorepackChannelNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货架号",
          field: "frameName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹状态",
          field: "packageStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员付款状态",
          field: "storepackStatusShow",
          width: "160",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拒收状态",
          field: "isRejectionShow",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "验货状态",
          field: "checkStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物品类",
          field: "itemCategoryShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "入库时间",
          field: "intoStockTime",
          width: "180",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "仓库",
          field: "storageName",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "包裹件数",
          field: "boxCount",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹重量",
          field: "packageWeight",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹体积",
          field: "packageVolume",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹备注",
          field: "packageComment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包批次",
          field: "billPackNumber",
          width: "120",
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "目的地",
          field: "areaCountryName",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "邮编",
          field: "postCode",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "添加包裹时间",
          field: "packageCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "到库签收时间",
          field: "billSignforCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包时间",
          field: "billStorepackCreateTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "出库时间",
          field: "outStockTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData: [
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
      ], //  表格数据
      // 第2步配置预览表头
      myTableHeard2: [
        {
          name: "运单号",
          field: "memberNickname",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "快递单号",
          field: "courierNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "出库单号",
          field: "billStorepackNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "转单号",
          field: "billStorepackChannelNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货架号",
          field: "frameName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹状态",
          field: "packageStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员付款状态",
          field: "storepackStatusShow",
          width: "160",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拒收状态",
          field: "isRejectionShow",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "验货状态",
          field: "checkStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物品类",
          field: "itemCategoryShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "入库时间",
          field: "intoStockTime",
          width: "180",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "仓库",
          field: "storageName",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "包裹件数",
          field: "boxCount",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹重量",
          field: "packageWeight",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹体积",
          field: "packageVolume",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹备注",
          field: "packageComment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包批次",
          field: "billPackNumber",
          width: "120",
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "目的地",
          field: "areaCountryName",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "邮编",
          field: "postCode",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "添加包裹时间",
          field: "packageCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "到库签收时间",
          field: "billSignforCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包时间",
          field: "billStorepackCreateTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "出库时间",
          field: "outStockTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData2: [], //  表格数据
      // 第3,调整路径
      myTableHeard4: [
        {
          name: "类型",
          field: "addressTypeShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务单号",
          field: "taskNumber",
          width: "190",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "190",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物",
          field: "aaaa",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "loadStatusShow",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "地址",
          field: "allAddress",
          width: "180",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData4: [], //  表格数据
      tableData51: [], //
      tableData52: [], //
      myTableHeard5: [
        {
          name: "费项",
          field: "itemCategoryName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "金额",
          field: "amount",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "paymentMethod",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "付款状态",
        //   field: "aaaa",
        //   width: "120",
        //   sort: 6,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard6: [
        {
          name: "操作人",
          field: "operatorUserName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "操作时间",
          field: "operatorTime",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "操作设备",
          field: "operatorDeviceShow",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "操作",
          field: "operatorName",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "日志描述",
          field: "operatorDescribe",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeardLeft: [
        {
          name: "货物",
          field: "goodsNames",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务编号",
          field: "number",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积",
          field: "volume",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethodShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "备注",
          field: "remarks",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      tableData6: [
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
      ], //
      tableDataRight: [],
      selectTableData: [],
      selectTableData2: [],
      selectTableData52: [],
      selectTableData51: [],
      totalArr: [],
      //   出车/完成确认数据
      formData5: {
        endFiles: "",
        endMileage: "",
        endRemarks: "",
        startFiles: "",
        startMileage: "",
        checkItemConfDictIds: [],
        checkItems: [],
        startRemarks: "",
      },
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      CarInfo: {
        carCategory: "",
        carNumber: "",
        carType: "",
        dispatchContractNumber: "",
        dispatchId: "",
        driverAttribute: "",
        driverName: ",",
        loadableCapacity: "",
        loadableVolume: "",
        number: "",
        supercargoName: "",
        trailerNumber: "",
      },

      storageList: [],
      returnCangReasonList: [],

      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      // 退单
      isShowDialog4: false,
      dialogTitle4: "",
      diaWidth4: "40%",
      dialogForm4: {
        taskIds: [],
        remarks: "",
        returnCangReason: "",
      },
      rulesForm4: {
        returnCangReason: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      // 外发到站
      isShowDialog5: false,
      dialogTitle5: "",
      diaWidth5: "50%",
      dialogForm5: {
        taskIds: [],
        fileIds: [],
        remarks: "",
      },
      rulesForm5: {
        aaaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      unloadTypeList: [
        {
          name: "正常卸货",
          val: "zheng_chang:unload_type",
        },
        {
          name: "回仓卸货",
          val: "hui_cang:unload_type",
        },
      ],
      isOutGoingList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      fileNameLists1: [], //装货确认
      fileNameListsfq: [], //发车前图片
      fileNameListsfh: [],
      fileNameLists3: [], //外发图片
      fileNameLists2: [], //卸货图片
      start_car_check_item_list: [], //卸货图片
      fileNameLists5: [], //卸货图片

      // ==== 弹窗组件属性 start ====
      isShowDialog1: false,
      dialogTitle1: "装货确认",
      diaWidth1: "60%",
      dialogForm1: {
        // 弹窗表单数据
        remarks: "",
        taskStr: "",
      },
      rulesForm1: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      loadSureMoreIds: [],
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    this.dispatchId = this.$route.query.dispatchId || "";
    let number = this.$route.query.number || "";
    if (this.dispatchId) {
      this.getPCH(number);
      // this.getData2();
      this.$nextTick(() => {
        this.queryBtns();
      });
    }
  },
  destroyed() {},
  methods: {
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.fileNameLists1 = [];

      this.dialogForm1 = {
        remarks: "",
        taskStr: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      console.log(this.fileNameLists1, "fileNameLists1");
      let fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.$API
        .wtl_loadSure({
          taskIds: this.loadSureMoreIds,
          fileIds: fileIds || [],
          remarks: this.dialogForm1.remarks || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData2();
          this.isShowDialog1 = false;
        });
    },

    // 装货确认
    loadSureMore() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要装货确认的任务");
        return false;
      }
      let ids = [];
      let str = "";
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
        str += item.number + " , ";
      });
      this.loadSureMoreIds = ids;
      this.dialogForm1.taskStr = str;

      this.isShowDialog1 = true;
      // this.$confirm("确定要把所选任务进行装货确认吗?", "提示")
      //   .then(() => {
      //     this.$API
      //       .wtl_loadSure({ taskIds: ids, fileIds: [], remarks: "" })
      //       .then((res) => {
      //         this.$message.success(res.data.message || "装货确认成功");
      //         this.getData2();
      //       });
      //   })
      //   .catch(() => {});
    },
    // 取消装货
    cancelLoadSure() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要取消装货的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行取消装货吗?", "提示")
        .then(() => {
          this.$API.wtl_cancelLoadSure({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "取消装货成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 取消卸货
    cancelunloadSure() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要取消卸货的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行取消卸货吗?", "提示")
        .then(() => {
          this.$API.wtl_cancelunloadSure({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "取消卸货成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 装货到车
    arrivalLoad() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要装货到车的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行装货到车吗?", "提示")
        .then(() => {
          this.$API.wtl_arrivalLoad({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "装货到车成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 卸货到车
    arrivalUnload() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要卸货到车的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行卸货到车吗?", "提示")
        .then(() => {
          this.$API.wtl_arrivalUnload({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "卸货到车成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 取消装货到车
    cancelArrivalLoad() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要取消装货到车的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行取消装货到车吗?", "提示")
        .then(() => {
          this.$API.cancelArrivalLoad({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "取消装货到车成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 取消卸货到车
    cancelArrivalUnload() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要取消卸货到车的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.$confirm("确定要把所选任务进行取消卸货到车吗?", "提示")
        .then(() => {
          this.$API.cancelArrivalUnload({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "取消卸货到车成功");
            this.getData2();
          });
        })
        .catch(() => {});
    },
    // 卸货确认
    unloadSure() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要卸货确认的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.dialogForm2.taskIds = ids;
      this.isShowDialog2 = true;
      this.dialogTitle2 = "卸货确认";
      this.getObjectUserDownList("storage"); //获取网点列表
      this.getConfDictValDownList("return_cang_reason"); //回仓原因
    },
    // 退单
    wtl_chargeback() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要退单的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.dialogForm4.taskIds = ids;
      this.isShowDialog4 = true;
      this.dialogTitle4 = "退单";
      this.getConfDictValDownList("return_cang_reason"); //回仓原因
    },
    // 外发到站
    wtl_outgoingStation() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请选择需要外发到站的任务");
        return false;
      }
      let ids = [];
      this.selectTableDataRight.forEach((item) => {
        ids.push(item.taskId);
      });
      this.dialogForm5.taskIds = ids;
      this.isShowDialog5 = true;
      this.dialogTitle5 = "外发到站";
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(type) {
      this.$COMAPI.getObjectUserDownList(type).then((res) => {
        if (type == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "return_cang_reason") {
            // 回仓原因
            this.returnCangReasonList = arrs;
          }
        });
    },
    // 获取发车批次出车确认信息
    wtl_getDispatchStartCarInfo() {
      this.$API
        .wtl_getDispatchStartCarInfo({
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          if (datas) {
            this.formData5 = datas;
            let checkItemConfDictIds = [];
            let arrs = datas.checkItems || [];
            arrs.forEach((item) => {
              checkItemConfDictIds.push(item.confDictId);
            });
            this.formData5.checkItemConfDictIds = checkItemConfDictIds;

            let startFiles = datas.startFiles || [];
            let endFiles = datas.endFiles || [];
            let array = [];
            let array2 = [];
            array = startFiles.map((item) => {
              let names = this.$TOOLS.getCurrentTime();
              names = new Date(names).getTime(); //获取时间戳当文件名
              let objs = {
                url: item,
                name: names,
              };
              return objs;
            });
            array2 = endFiles.map((item) => {
              let names = this.$TOOLS.getCurrentTime();
              names = new Date(names).getTime(); //获取时间戳当文件名
              let objs = {
                url: item,
                name: names,
              };
              return objs;
            });
            this.fileNameListsfq = array;
            this.fileNameListsfh = array2;
            //
          }
        });
    },
    // 获取发车批次出车确认信息
    wtl_getDispatchOperateLog() {
      this.$API
        .wtl_getDispatchOperateLog({ dispatchId: this.dispatchId })
        .then((res) => {
          this.tableData6 = res.data.result;
        });
    },
    // 根据页面加载数据
    getDatas(activeName) {
      if (!this.dispatchId) {
        this.$message.warning("请先选择发车批次号");
        return false;
      }
      if (activeName == "first") {
        this.$refs.refLoadingDetails.getDispatchDetailApi();
      } else if (activeName == "one") {
        this.getData2();
      } else if (activeName == "two") {
        this.getDispatchAddrList();
      } else if (activeName == "three") {
        this.getData2();
        // 获取车辆信息
        this.getDispatchCarInfo();
      } else if (activeName == "four") {
        this.wtl_getDispatchFinance();
      } else if (activeName == "five") {
        // 出车确认信息
        this.wtl_getDispatchStartCarInfo();
        this.$COMAPI
          .getConfDictValDownList("start_car_check_item")
          .then((res) => {
            this.start_car_check_item_list = res || [];
          }); //出车检查项
      } else if (activeName == "six") {
        // 操作日志
        this.wtl_getDispatchOperateLog();
      }
    },
    // 点击tabs切换
    tabsClick(e) {
      this.pageStart = 1;
      this.getDatas(e.name);
    },
    changePCH(e) {
      if (e) {
        this.getDatas(this.activeName);
      }
    },
    queryBtns(e) {
      if (!this.dispatchId) {
        this.$message.warning("请先输入批次号");
        return false;
      }
      this.getDatas(this.activeName);
    },
    getPCH(e) {
      this.$API.wtl_getDispatchList({ number: e }).then((res) => {
        this.NumberList = res.data.result.data || [];
      });
    },
    handleSelectionChange51(e) {
      this.selectTableData51 = e;
    },
    // 表格选择事件(第五步,应收)
    handleSelectionChange52(e) {
      this.selectTableData52 = e;
    },
    // 任务模式
    getData2() {
      const  this_ =this
      this.$API
        .wtl_getDispatchTaskList({
          dispatchId: this.dispatchId,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.tableDataRight = res.data.result.data || [];
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        });
    },
    // 获取发车批次对应的装卸信息(路线调整)
    getDispatchAddrList() {
      this.$API
        .wtl_getDispatchAddrList({
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          this.tableData4 = res.data.result.data || [];
        });
    },
    // 获取财务信息
    wtl_getDispatchFinance() {
      this.$API
        .wtl_getDispatchFinance({ dispatchId: this.dispatchId })
        .then((res) => {
          this.tableData51 = res.data.result.financeOutVos || []; //应付
          this.tableData52 = res.data.result.financeInVos || []; //应收
        });
    },
    rowclick2(row, event, column) {
      this.$refs.mytable2.toggleRowSelection(row);
    },
    //
    handleSelectionChange(e) {
      this.selectTableDataRight = e;
    },
    // 查看货物明细:
    getGoodsNameDetails(row) {
      // this.dialogForm2 = row;
      this.$API.wtl_getTaskItems({ taskId: row.taskId }).then((res) => {
        this.goodsNameData = res.data.result || [];
        this.isShowDialog3 = true;
      });
    },

    handleCloseDia3(e) {
      this.isShowDialog3 = false;
    },

    reload2() {
      this.getData2();
      // 获取车辆信息
      this.getDispatchCarInfo();
    },

    // 获取车辆信息
    getDispatchCarInfo() {
      this.$API
        .wtl_getDispatchCarInfo({ dispatchId: this.dispatchId })
        .then((res) => {
          let datas = res.data.result || "";
          if (datas) {
            this.CarInfo = datas;
            // this.$message.success(res.data.message || "加载成功");
          }
        });
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    handleSelectionChange2(e) {
      // 表格选择事件
      this.selectTableData2 = e;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight(type) {
      let types = type || this.activeName;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let btnListHeight = this.$refs.btnList.offsetHeight || 40; // 按钮列表高度

      var otherHeight = 0;
      if (types == "one") {
        otherHeight = btnListHeight + 60 + 70 + 65; //60是顶部导航 40是tabs 65是上面查询条件
      } else if (types == "two") {
        let btnList3Height = this.$refs.btnList2.offsetHeight || 40; // 按钮列表高度
        let detailsBox2Height = this.$refs.detailsBox2.offsetHeight || 40; // 配载详情

        otherHeight = btnList3Height + (detailsBox2Height + 20) + 60 + 40 + 30; //60是顶部导航 40是tabs
      } else if (types == "three") {
        otherHeight = 60 + 40 + 30; //60是顶部导航 40是tabs 30是上下15的padding
      }

      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        if (types == "one") {
          this.tableHeigth2 = tabHeight;
          console.log(" this.tableHeigth2", this.tableHeigth2);
          this.$refs.mytable2.doLayout();
        } else if (types == "two") {
        } else if (types == "three") {
          this.tableHeigth4 = tabHeight;
          this.$refs.mytable4.doLayout();
        }
      });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      };
      this.fileNameLists2 = [];
      this.fileNameLists3 = [];
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn2(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm2));

      let arr1 = this.fileNameLists2.map((item) => {
        return item.name;
      });
      let arr2 = this.fileNameLists3.map((item) => {
        return item.name;
      });

      param.fileIds = arr1 || [];
      param.outgoingFileIds = arr2 || [];
      this.$API.wtl_unloadSure(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog2 = false;
        this.getData2();
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },
    /**
     * 退单
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia4() {
      this.isShowDialog4 = false;
      this.dialogForm4 = {
        taskIds: [],
        remarks: "",
        returnCangReason: "",
      };
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn4(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm4));
      this.$API.wtl_chargeback(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog4 = false;
        this.getData2();
      });
    },
    /**
     * 外发到站
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia5() {
      this.isShowDialog5 = false;
      this.dialogForm5 = {
        taskIds: [],
        fileIds: [],
        remarks: "",
      };
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn5(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm5));
      let arrs = [];
      this.fileNameLists5.forEach((item) => {
        arrs.push(item.name);
      });
      param.fileIds = arrs;
      this.$API.wtl_outgoingStation(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog5 = false;
        this.getData2();
      });
    },

    // 选择图片(装货确认)
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },
    // 选择图片(发车前图片)
    changeFileList(array) {
      this.fileNameListsfq = array;
    },
    // 选择图片(发车完成图片)
    changeFileListfh(array) {
      this.fileNameListsfh = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },
    // 选择图片
    changeFileList3(array) {
      this.fileNameLists3 = array;
    },
    // 选择图片
    changeFileList5(array) {
      this.fileNameLists5 = array;
    },
  },
};
</script>
<style scoped lang='less'>
.detailsBox {
  display: flex;
  flex-wrap: wrap;
  background-color: #f2f2f2;
  padding: 10px 10px 0;
  font-size: 16px;
  margin-bottom: 20px;

  .item {
    display: flex;
    margin-right: 40px;
    min-width: 180px;
    margin-bottom: 10px;

    .dItemLabel {
      margin-right: 10px;
    }
    .ditemBtn {
      color: #0000ff;
      margin-left: 20px;
    }
  }
}
// 查询条件边框线
@borderColor: #cccccc;

.h3title {
  //   background-color: #f2f2f2;
  //   padding: 10px;
  //   border-bottom: 1px solid @borderColor;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.formBtns {
  height: 30px;
  margin: 0;
  padding: 0 10px;
}
</style>